import { SxProps, Typography, useTheme } from '@mui/material';

import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { pxToRem } from '@/theme/typography';

interface DialogFormTitleProps {
  message: string;
  sx?: SxProps;
}

export const DialogFormTitle: FC<DialogFormTitleProps> = ({ message, sx }) => {
  const theme = useTheme();

  return (
    <Typography
      component='span'
      sx={{
        display: 'block',
        marginBottom: {
          mobile: '36px',
          tablet: pxToRem(48),
        },
        fontSize: {
          mobile: '18px',
          tablet: pxToRem(22),
        },
        fontFamily: theme.palette.typography.font.bold,
        letterSpacing: {
          mobile: '0.1px',
          tablet: 'normal',
        },
        color: theme.palette.grey[90],
        ...sx,
      }}
    >
      <FormattedMessage id={message} />
    </Typography>
  );
};
